import Vue from 'vue';
import dayjs from 'dayjs';
import Pikaday from 'pikaday';
const BfDatePicker = Vue.extend({
    props: {
        /** date string */
        value: { type: String, required: false, default: '' },
        /** format that selected date will be emitted in */
        format: { type: String, required: false, default: 'DD/MM/YYYY' },
        /** text to display when no date selected */
        placeholder: { type: String, required: false, default: '' },
        config: { type: Object, required: false, default: () => ({}) },
    },
    data() {
        return {
            picker: null
        };
    },
    mounted() {
        this.picker = new Pikaday({
            field: this.$refs['bf-datepicker'],
            format: this.format,
            onSelect: (date) => {
                this.$emit('input', dayjs(date).format(this.format));
            },
            ...this.config,
        });
    },
    beforeDestroy() {
        this.picker.destroy();
    }
});
export default BfDatePicker;
